/**
 * Centralized SEO-optimized training URL configuration.
 * All training links across the site should use these helpers.
 */

export const trainingUrls = {
  fr: {
    main: '/formation-ia-avocat',
    fco: '/formation-continue-obligatoire-avocat-ia',
    adHoc: '/formation-ia-sur-mesure-cabinet-avocat',
    customSolutions: '/solution-ia-juridique-sur-mesure',
    eligibleCatalog: '/formation-ia-juridique-eligible-financement',
    enroll: '/inscription-formation-ia',
    generalManagement: '/formation-ia-direction-generale',
    eligible: {
      legalDesign: '/formation-legal-design-ia-avocat',
      contractual: '/formation-ia-contrat-avocat',
      litigation: '/formation-ia-contentieux-avocat',
      research: '/formation-ia-recherche-juridique',
      website: '/formation-ia-site-web-avocat',
      security: '/formation-ia-securite-secret-professionnel',
    },
  },
  en: {
    main: '/legal-ai-training-lawyers',
    fco: '/mandatory-cle-ai-training-lawyers',
    adHoc: '/custom-ai-training-law-firm',
    customSolutions: '/custom-legal-ai-solutions',
    eligibleCatalog: '/legal-ai-training-eligible-funding',
    enroll: '/enroll-legal-ai-training',
    generalManagement: '/ai-training-general-management',
    eligible: {
      legalDesign: '/legal-design-ai-training',
      contractual: '/ai-contract-drafting-training',
      litigation: '/ai-litigation-training',
      research: '/ai-legal-research-training',
      website: '/ai-lawyer-website-training',
      security: '/ai-security-professional-secrecy-training',
    },
  },
} as const;

/** Get the training URLs for a given language */
export const getTrainingUrls = (language: string) =>
  language === 'fr' ? trainingUrls.fr : trainingUrls.en;

/** Get canonical domain + path for a training URL */
export const getTrainingCanonical = (language: string, key: keyof typeof trainingUrls.fr) =>
  `https://gaius-tech.com${language === 'fr' ? trainingUrls.fr[key] : trainingUrls.en[key]}`;

/** Map eligible training slug to SEO-optimized path */
const eligibleSlugMap: Record<string, keyof typeof trainingUrls.fr.eligible> = {
  'legal-design-ia': 'legalDesign',
  'legal-design-ai': 'legalDesign',
  'ia-taches-contractuelles': 'contractual',
  'ai-contractual-tasks': 'contractual',
  'ia-contentieux': 'litigation',
  'ai-litigation': 'litigation',
  'ia-recherche-juridique': 'research',
  'ai-legal-research': 'research',
  'ia-site-web-avocat': 'website',
  'ai-lawyer-website': 'website',
  'ia-securite-secret-professionnel': 'security',
  'ai-security-professional-secrecy': 'security',
};

export const getEligibleTrainingPath = (language: string, slug: string): string => {
  const urls = getTrainingUrls(language);
  const key = eligibleSlugMap[slug];
  if (key) return urls.eligible[key];
  // Fallback for unknown slugs
  return `${urls.eligibleCatalog}/${slug}`;
};
